import { fg } from '@atlassian/jira-feature-gating';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarDefaultPINFiltersResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/project-filters/index.tsx';
import { sidebarProjectIssuesResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/project-sidebar-common/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { isNinGlobalScopeEnrolmentEnabledResource } from '@atlassian/jira-router-resources-is-nin-global-scope-enrolment-enabled/src/index.tsx';
import {
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
	issueNavigatorHydrationRelayResourceBrowserOnly,
	issueNavigatorFilterRefinementRelayResource,
} from '@atlassian/jira-router-resources-issue-navigator/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getAIContextPanelResources } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';
// eslint-disable-next-line camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@atlassian/jira-router-resources-business-project-details/src/index.tsx';
import { projectThemeResource } from '@atlassian/jira-router-resources-project-theme/src/index.tsx';

const getAIContextPanelResourcesWithCondition = () =>
	fg('empanada_nin_resource_audit_2025') ? [] : getAIContextPanelResources();

export const getCommonProjectResources = ({
	isUsingSidebarEntrypoint,
}: {
	isUsingSidebarEntrypoint?: boolean;
} = {}) => [
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	resourceWithCondition2(
		() => fg('nin_request_hydrate_query_earlier') && !fg('render_jql_builder_in_ssr'),
		issueNavigatorHydrationRelayResourceBrowserOnly,
	),
	resourceWithCondition2(
		() => fg('render_jql_builder_in_ssr'),
		issueNavigatorHydrationRelayResource,
	),
	resourceWithCondition2(
		() => fg('list_lovability_improving_filters'),
		issueNavigatorFilterRefinementRelayResource,
	),
	...getNavigationResources({ isUsingSidebarEntrypoint }),
	// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
	resourceWithCondition2(
		// not used, removing
		() => !fg('empanada_nin_resource_audit_2025'),
		incidentExperimentTraitResource,
	),
	projectContextResource,
	resourceWithCondition2(
		// moving to JSM NIN only
		() => !fg('empanada_nin_resource_audit_2025'),
		forgeProjectModuleResource,
	),
	staticSidebarShortcutsResource,
	staticProjectSidebarNavigationResource,
	resourceWithCondition2(
		// moving to JSM NIN only
		() => !fg('empanada_nin_resource_audit_2025'),
		staticProjectSidebarConnectAddonsNavigationResource,
	),
	// end of resources expanded from getNavigationSidebarProjectResource
	resourceWithCondition2(
		// not used, removing
		() => !fg('empanada_nin_resource_audit_2025'),
		DEPRECATED_DO_NOT_USE_projectDetailsResource,
	),
	projectThemeResource,
	resourceWithCondition2(
		// not used, removing
		() => !fg('empanada_nin_resource_audit_2025'),
		sidebarProjectIssuesResource,
	),
	resourceWithCondition2(
		() => !fg('nin_remove_global_scope_enrolment'),
		isNinGlobalScopeEnrolmentEnabledResource,
	),
	resourceWithCondition2(
		// moving to JSM NIN only
		() => !fg('empanada_nin_resource_audit_2025'),
		staticSidebarDefaultPINFiltersResource,
	),
	...getAIContextPanelResourcesWithCondition(),
];
